var map = {
	"./bongdunia-news.md": [
		133,
		7
	],
	"./creative-bulb.md": [
		134,
		8
	],
	"./gounique-in.md": [
		135,
		9
	],
	"./indus-record.md": [
		136,
		10
	],
	"./minimal-art.md": [
		137,
		11
	],
	"./thedeals-guru.md": [
		138,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 52;
module.exports = webpackAsyncContext;